export default __webpack_public_path__ + "img/bIofBwjQ.81d87f0c.svg";